import * as Sentry from '@sentry/capacitor';
import { Build, Env } from '@stencil/core';
import { store } from '../store/stencil-redux';
import { getAppConfigEnvironmentName, getAppProjectId, getAuthUser } from "../store/selectors";
import { filterBreadcrumb, MAX_BREADCRUMBS } from './sentry-breadcrumbs';

const SENTRY_DSN = 'https://e625cb3e9eec46f3a2931441ad0eb2cb@o416754.ingest.us.sentry.io/5354545';

export const isSentryEnabled = () => {
  return Build && !Build.isDev;
}

export const setupSentry = () => {

  if (!isSentryEnabled()) {
    return;
  }

  // Read at send time: the environment is restored by redux-persist and can be switched at runtime.
  Sentry.addEventProcessor(event => {
    const reduxState = store.getState();
    const user = getAuthUser(reduxState);
    event.environment = getAppConfigEnvironmentName(reduxState);
    event.tags = {
      ...(event.tags || {}),
      projectId: getAppProjectId(reduxState)
    };
    event.user = {
      id: user?.userId,
      email: user?.email,
      username: user?.username
    };
    return event;
  });
};

// Release and dist come from CI. Web builds fall back to the commit (see stencil.config.ts).
export const initSentry = () => isSentryEnabled() && Sentry.init({
  dsn: SENTRY_DSN,
  normalizeDepth: 10,
  release: Env['sentryRelease'],
  dist: Env['sentryDist'],
  // Native crashes, ANRs and sessions keep this value; JS events are corrected by the event processor above.
  environment: 'prod',
  enableLogs: true,
  maxBreadcrumbs: MAX_BREADCRUMBS,
  beforeBreadcrumb: filterBreadcrumb,
});

export default Sentry;
